module.exports = __webpack_public_path__ + "static/media/ZFC.8315ba34.pdf";